<template>
    <div class="section-mobile-number">
        <div class="section-mobile-number__content-header">
            <ButtonCustom
                type="go-back"
                text="mobile number"
                :isGoBackHistory="false"
                @onClickButton="$emit('onClickGoBack')"
            />

            <div class="section-mobile-number__box-btn-desktop" slot="button">
                <button
                    class="t-transform-cap"
                    type="submit"
                    :disabled="isLoadingButton"
                    @click="onSubmitForm"
                >
                    <b-spinner v-if="isLoadingButton" />
                    {{ getTranslatedText("continue to transfer") }}
                    <img
                        src="@/assets/images/wallet/vector-right.png"
                        alt="vector-right"
                    />
                </button>
            </div>

            <div
                class="section-mobile-number__transfer-amount section-mobile-number__transfer-amount__mobile"
            >
                <p
                    class="section-mobile-number__transfer-amount-text t-transform-cap"
                >
                    {{ getTranslatedText("transfer amount") }}
                </p>
                <div class="section-mobile-number__transfer-amount-price">
                     <b-form-input
                        v-model="amount"
                        id="input-add-credit"
                        @blur="formatter"
                        @keydown.native="checkDigit"
                    ></b-form-input>
                    <!-- <b-form-input
                        v-model="amount"
                        id="input-amount-phone"
                        @blur="formatter"
                        @keydown.native="checkDigit"
                    ></b-form-input> -->
                    <span>{{ getTranslatedText("OMR") }}</span>
                </div>
            </div>
        </div>

        <div class="section-mobile-number__content-form">
            <div
                class="section-mobile-number__transfer-amount section-mobile-number__transfer-amount__desktop"
            >
                <p
                    class="section-mobile-number__transfer-amount-text t-transform-cap"
                >
                    {{ getTranslatedText("transfer amount") }}
                </p>
                <div class="section-mobile-number__transfer-amount-price">
                    <b-form-input
                        :placeholder="getTranslatedText('0.00 OMR')"
                        v-model="amount"
                        id="input-amount-phone-transfer"
                        @blur="formatter"
                        @keydown.native="checkDigit"
                    ></b-form-input>
                </div>
            </div>
            <p class="section-mobile-number__content-form-title">
<!--                {{-->
<!--                    getTranslatedText(-->
<!--                        `minimum the withdrawal amount is ${limitAmount} OMR`-->
<!--                    )-->
<!--                }}-->
            </p>
            <FormCommon
                :formItem="formItem"
                :dataForm="dataForm"
                @update-form-data="updateFormData"
                @onSubmitForm="onSubmitForm"
            >
                <b-input-group-prepend
                    slot="propend-phone-number"
                    class="phone-code"
                >
                    <button
                        class="show-dropdown"
                        type="button"
                        @click="showDropDow"
                    >
                        <img
                            class="user-avatar"
                            :src="
                                require(`@/assets/images/flags/${dataForm.flag}`)
                            "
                            :alt="dataForm.flag"
                        />
                        <span class="name-country">{{
                            dataForm.nameCountry
                        }}</span>
                        ({{ dataForm.calling_code }})
                    </button>

                    <b-dropdown ref="select_phone_code">
                        <b-form-input
                            v-model="textSearchPhoneNumber"
                            :placeholder="getTranslatedText('search')"
                            @input="onChangeFilterPhoneNumbers"
                        ></b-form-input>
                        <b-dropdown-item
                            @click="selectPhoneCode(item)"
                            v-for="(item, index) in phoneNumbersFilter"
                            :key="index"
                        >
                            <div>
                                <img
                                    class="user-avatar"
                                    :src="
                                        require(`@/assets/images/flags/${item.flag}`)
                                    "
                                    :alt="item.flag"
                                />
                                <span class="name-country">{{
                                    item.name
                                }}</span>
                                ({{ item.number }})
                            </div>
                        </b-dropdown-item>
                    </b-dropdown>
                </b-input-group-prepend>

                <p
                    slot="textOr"
                    class="section-mobile-number__text-form t-transform-cap"
                >
                    {{ getTranslatedText("or") }}
                </p>

                <div class="section-mobile-number__box-btn" slot="button">
                    <button
                        class="t-transform-cap"
                        type="submit"
                        :disabled="isLoadingButton"
                    >
                        <b-spinner v-if="isLoadingButton" />
                        {{ getTranslatedText("continue to transfer") }}
                        <img
                            src="@/assets/images/wallet/vector-right.png"
                            alt="vector-right"
                        />
                    </button>
                </div>
            </FormCommon>
        </div>
    </div>
</template>
<script>
import { phoneNumbers } from "@/resources/phoneNumber";
import {
    checkDigitCommon,
    filterFullTextSearch,
    isStrEmpty,
} from "@/components/common/utils";

import FormCommon from "@/components/common/form";
import ButtonCustom from "@/components/common/button";
import languageMixin from "@/mixins/language/language-mixin";

const VUE_APP_WITH_AMOUNT = process.env.VUE_APP_WITH_AMOUNT;
const VUE_APP_WITH_AMOUNT_MAXIUM = process.env.VUE_APP_WITH_AMOUNT_MAXIUM;
const VUE_APP_WITH_AMOUNT_MINIMUM = process.env.VUE_APP_WITH_AMOUNT_MINIMUM;

export default {
    mixins: [languageMixin],
    props: {
        isLoadingButton: {
            type: Boolean,
            default: false,
        },
    },
    components: { FormCommon, ButtonCustom },
    data() {
        return {
            toastData: {
                message: "",
                type: "success",
            },
            textSearchPhoneNumber: '',
            limitAmount: VUE_APP_WITH_AMOUNT,
            minimumAmount: VUE_APP_WITH_AMOUNT_MINIMUM,
            maxiumAmount: VUE_APP_WITH_AMOUNT_MAXIUM,
            phoneNumbers,
            phoneNumbersFilter: phoneNumbers,
            amount: VUE_APP_WITH_AMOUNT_MINIMUM,
            dataForm: {
                flag: "Flag_of_Oman.svg",
                calling_code: "+968",
                phone: "",
                email: "",
                nameCountry: "Oman",
            },
            formItem: [
                {
                    type: "input-group",
                    typeInput: "text",
                    placeholder: "",
                    name: "phone",
                    label: "phone number",
                    for: "input-phone",
                    id: "input-phone",
                    prepend: "code",
                    nameSlotInputPrepend: "propend-phone-number",
                    state: null,
                    textInvalid: "please enter phone",
                    checkDigit: this.checkDigit,
                },
                {
                    type: "slot",
                    nameSlot: "textOr",
                },

                {
                    type: "input",
                    typeInput: "email",
                    placeholder: "someone@example.com",
                    name: "email",
                    showIconRequired: false,
                    label: "email",
                    for: "input-email",
                    id: "input-email",
                    state: null,
                    textInvalid: "please enter email",
                },
            ],
        };
    },
    mounted() {
        // let input = document.getElementById("input-amount-phone");
        // // input.addEventListener("input", this.resizeInput);
        // this.resizeInput.call(input);
    },
    methods: {
        resizeInput() {
            let input = document.getElementById("input-amount-phone");
            input.style.width =
                input.value.replaceAll(".", "").length + 1 + "ch";
        },

        onSubmitForm() {
            if (
                !this.amount ||
                parseFloat(this.amount.replace(",", "")) === 0
            ) {
                this.$emit(
                    "showToast",
                    "please enter transfer amount",
                    "error"
                );

                return false;
            }

            if (
                parseFloat(this.amount.replace(",", "")) <
                parseFloat(this.minimumAmount)
            ) {
                this.$emit(
                    "showToast",
                    "Minimum withdrawal amount is " + this.minimumAmount + " OMR",
                    "error"
                );

                return false;
            }

            if (
                parseFloat(this.amount.replace(",", "")) >
                parseFloat(this.maxiumAmount)
            ) {
                this.$emit(
                    "showToast",
                    "Maximum withdrawal amount is " +
                        this.maxiumAmount +
                        " OMR",
                    "error"
                );

                return false;
            }

            let param = { ...this.dataForm };
            param["amount"] = parseFloat(this.amount.replace(",", ""));
            this.$emit("onSubmit", param);
        },

        updateFormData(item) {
            let { value, name } = item;
            this.dataForm[name] = value;
        },

        // change phone code
        selectPhoneCode(item) {
            if (
                this.dataForm.calling_code !== item.number &&
                !isStrEmpty(this.dataForm.phone)
            ) {
                let event = {
                    target: {
                        value: this.dataForm.phone,
                        name: "phone",
                    },
                };

                let phoneCode = item.number;

                this.onBurInputFormData(event, phoneCode);
            }
            this.dataForm.calling_code = item.number;
            this.dataForm.code = item.number;
            this.dataForm.flag = item.flag;
            this.dataForm.nameCountry = item.name.replace(
                /^(.{5}[^\s]*).*/,
                "$1"
            );
            this.textSearchPhoneNumber = "";
            this.phoneNumbersFilter = phoneNumbers;
        },
        showDropDow() {
            const dropdown = this.$refs.select_phone_code;
            dropdown.show();
        },

        formatter(event) {
            const { value } = event.target;
             let isContainsLowercase = /^(?=.*[a-z]).*$/;

            this.amount = !isStrEmpty(value) && !isContainsLowercase.test(value) ? parseFloat(value.replace(/,/g, ""))
                .toFixed(2)
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0.00';
            // let input = document.getElementById("input-amount-phone");
            // let length = this.amount.replaceAll(".", "").length;
            // let numberMore = (this.amount.match(/,/g) || []).length;
            // numberMore = numberMore > 0 ? -numberMore + 1 : 0.5;
            // input.style.width = length + numberMore + "ch";
        },

        checkDigit(event) {
            return checkDigitCommon(event);
        },
        onChangeFilterPhoneNumbers(value) {
            let phoneNumber = [...phoneNumbers];
            if (!isStrEmpty(value)) {
                this.phoneNumbersFilter = filterFullTextSearch(
                    phoneNumber,
                    value,
                    "name",
                    "number"
                );
            } else {
                this.phoneNumbersFilter = phoneNumber;
            }
        },
    },
};
</script>

<style scoped lang="scss" src="@/assets/scss/mobile/wallet/_wallet.scss" />
